import { Navigate } from "react-router-dom";
import { useAuth, homePath } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import AppLayout from "@/components/AppLayout";

export default function Private({ roles, children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#F8FAFC]">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homePath(user.role)} replace />;
  return <AppLayout>{children}</AppLayout>;
}
